import { computed, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ViewParticipateService {
    participateconfig = {
        story: null,
        item: null,
        campaignId: null,
    }; 
    participateconfconfig = { };
    private _participateconfToggle = signal<any | null>(null);
    private _showParticipateConfPopup = signal<Boolean>(false);
    participateconfToggleClose = computed(() => this._showParticipateConfPopup())
    private _participateToggle = signal<any | null>(null);
    participateToggle = computed(() => this._participateToggle());
    participateconfToggle = computed(() => this._participateconfToggle());

    showParticipate(config: Partial<any>) {
        this._participateToggle.set({
            ...this.participateconfig,
            ...config
        });
    }

    hideParticipate() {
        this._participateToggle.set(null);
    }

    showParticipateconf(config: Partial<any>) {
        this._participateconfToggle.set({
            ...config
        });
    }

    hideParticipateconf() {
        this._participateconfToggle.set(null);
    }

     showParticipateConfPopup(config:Boolean) {
        this._showParticipateConfPopup.set(config);
    }

    hideParticipateConfPopup() {
        this._showParticipateConfPopup.set(false);
    }

}